module.exports = __webpack_public_path__ + "static/media/scan0369.28229169.jpg";